module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "batch-user-manage"
    }
  }, [_c('table', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Category")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Universe")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Algo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("CLang")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("PyLang")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Remove users not in list from category")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remove),
      expression: "remove"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.remove) ? _vm._i(_vm.remove, null) > -1 : (_vm.remove)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.remove,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.remove = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.remove = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remove = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-4"
  }, [_vm._v("Emails to add to category")]), _vm._v(" "), _c('td', {
    staticClass: "col grid"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emails),
      expression: "emails"
    }],
    staticClass: "col-12",
    attrs: {
      "placeholder": "One email per line"
    },
    domProps: {
      "value": (_vm.emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emails = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col-12"
  }, [_c('button', {
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col-4"
  }), _vm._v(" "), _c('th', {
    staticClass: "col"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec6644b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/BatchUserManage.vue
// module id = 581
// module chunks = 0